import { render, staticRenderFns } from "./FreQuent.vue?vue&type=template&id=05cc32db&"
import script from "./FreQuent.vue?vue&type=script&lang=js&"
export * from "./FreQuent.vue?vue&type=script&lang=js&"
import style0 from "./FreQuent.vue?vue&type=style&index=0&id=05cc32db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports